import { AttributeName } from '@aon/tws-common-ui-questions/build/lib/models';
import _ from 'lodash';
import { EditState, IAddedQuestion, IOrderedItem, ISurveyQuestionEditModel, QuestionType, SourceType } from './';
import { ElementType } from './ElementType';

export class SurveyQuestionEditModel implements ISurveyQuestionEditModel {
	public id: number;
	public editState: EditState;
	public isActive: boolean;
	public surveyQuestionId?: number;
	public sourceQuestionVariationId?: number;
	public code?: string;
	public sourceResponseOptionGroupId?: number;
	public text: string;
	public dimensionNames?: string[];
	public responseOptionGroup?: string;
	public responseOptions?: string[];
	public isDemographic: boolean;
	public questionType: QuestionType;
	public attributeName?: AttributeName;
	public externalAttributeColumnName?: string;
	public sourceType: SourceType;
	public existingTranslations: string[];
	public isRequired: boolean;
	public ownerId?: number;
	public elementType: ElementType = ElementType.Question;
	public hasUpdates?: boolean;
	public parentQuestionId?: number;
	public displayRulesCount: number;

	public constructor(question: IAddedQuestion, editState?: EditState) {
		this.id = 0;
		this.isActive = editState === undefined || editState !== EditState.Remove;
		this.surveyQuestionId = undefined;
		this.sourceQuestionVariationId = question.questionVariationId;
		this.isDemographic = question.isDemographic;
		this.questionType = question.questionType;
		this.attributeName = question.attributeName;
		this.externalAttributeColumnName = question.externalAttributeColumnName;
		this.sourceType = question.sourceType;
		this.text = question.text;
		this.dimensionNames = question.dimensionNames;
		this.sourceResponseOptionGroupId = question.responseOptionGroupId;
		this.responseOptionGroup = question.responseOptionGroup;
		this.existingTranslations = question.languages;
		this.isRequired = true;
		this.ownerId = question.ownerId;
		this.hasUpdates = false;
		this.parentQuestionId = question.parentQuestionId;
		this.displayRulesCount = 0;

		if (editState !== undefined) {
			this.editState = editState;
		} else if (question.editState !== undefined) {
			this.editState = question.editState;
		} else {
			this.editState = EditState.Add;
		}

		if (question.responseOptions !== null) {
			const orderedOptions = _.orderBy(question.responseOptions, ['displayOrder']);
			this.responseOptions = _.map(orderedOptions, (ro: IOrderedItem) => ro.displayText);
		}
		if (question.sourceType === SourceType.Custom) {
			this.surveyQuestionId = question.questionId;
			this.sourceResponseOptionGroupId = !question.isDemographic ? question.responseOptionGroupId : undefined;
		}
	}
}
